<template>
  <div class="animated fadeIn">
    <b-modal
      ref="modal-upload-contact"
      scrollable
      centered
      size="xl"
      button-size="sm"
      @hidden="onReset"
    >
      <template #modal-title>
        <i class="fas fa-file-import"></i> IMPORTAR CONTATOS
      </template>
      <div class="col-md-12">
        <div class="form-group">
          <label for="txtDescription"> Importar Arquivo:</label>
          <div
            draggable="true"
            @drop.prevent="onDrop"
            @dragover.prevent
            class="block-upload"
            @click="addFile()"
          >
            <div
              v-if="file === null"
              class="text-center pt-5 pb-5"
            >
              Clique ou arraste e solte os arquivos aqui
            </div>
            <div
              v-else
              class="text-center pt-5 pb-5"
            >
              {{ file.name }}
            </div>
          </div>
          <div style="display: none">
            <input
              type="file"
              ref="planilha"
              @change="handleFileUpload()"
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/excel"
            />
          </div>
        </div>
      </div>
      <div class="col-md-12 pt-4">
        <div class="form-group">
          <label for="txtDescription"> Modelo do Arquivo:</label>
          <div>
            <li>
              <a
                href="https://static.nexum.com.br/template/planilhas/ListaContatos.xlsx"
                target="_blank"
                ><i class="fas fa-file-excel text-third"></i
                ><small class="pl-1"
                  >Clique aqui para baixar o modelo do arquivo de importação de
                  contatos</small
                ></a
              >
            </li>
          </div>
        </div>
      </div>
      <template #modal-footer>
        <div class="w-100 text-right">
          <button
            type="button"
            class="btn btn-third btn-sm"
            v-b-tooltip.hover
            :title="'Importar'"
            @click.prevent="onImport"
          >
            <i class="fas fa-check-circle"></i>
            <span class="d-md-down-none"> Importar</span>
          </button>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
// import Tools from '@/components/tools/Tools.js'
import { loading, toast } from '@/shared/utils/UIHelper'
import * as XLSX from 'xlsx'
// import _ from 'lodash'

import ListaContatoRepository from '@/shared/http/repositories/configurations/listacontato.js'

export default {
  name: 'ModalUploadContact',
  mixins: [ActionsForm],
  data () {
    return {
      data: null,
      form: null,
      file: null,
      persons: [],
      campanhaListaId: null
    }
  },
  computed: {
    importFile () {
      var result = []
      if (this.files && this.files.length > 0) {
        result = this.files
      }
      return result
    }
  },
  watch: {
    file (value) {
      if (value !== null) {
        this.onReadFile()
      }
    }
  },
  methods: {
    onLoad () {},
    showModal (id) {
      // this.onReset()
      this.campanhaListaId = id
      this.$refs['modal-upload-contact'].show()
    },
    hideModal () {
      this.$refs['modal-upload-contact'].hide()
      this.onReset()
      this.$emit('created')
    },
    onReset () {
      this.file = null
      this.persons = []
      this.campanhaListaId = null
    },
    addFile () {
      this.$refs.planilha.click()
    },
    handleFileUpload () {
      var file = this.$refs.planilha.files[0]
      this.file = file
    },
    onDragOver (event) {
      event.preventDefault()
      event.dataTransfer.dropEffect = 'move'
    },
    onDrop (event) {
      var file = event.dataTransfer.files[0]
      this.file = file
    },
    onReadFile () {
      const reader = new FileReader()
      let excelData = []

      reader.onload = () => {
        loading.push()
        const fileData = reader.result
        const wb = XLSX.read(fileData, { type: 'binary' })

        wb.SheetNames.forEach((sheetName) => {
          excelData.push(...XLSX.utils.sheet_to_json(wb.Sheets[sheetName]))
        })

        this.parseToImport(excelData)
        loading.pop()
      }

      reader.readAsBinaryString(this.file)
    },
    parseToImport (data) {
      let persons = []
      if (data && data.length > 0) {
        persons = data.map((obj) => ({
          campanhaListaId: this.campanhaListaId,
          documento: obj.CPF_CNPJ,
          nome: obj.NOME,
          email: obj.EMAIL,
          celular: obj.CELULAR,
          numId: obj.NUMID
        }))
      }
      this.persons = persons
    },
    onImport () {
      if (this.persons) {
        this.data = this.persons
        ListaContatoRepository.Import(this.data)
          .then((response) => {
            if (response.status === 201) {
              this.hideModal()
              toast.success(this.$lang.Common.Alerts.Success)
            }
          })
          .catch(this.onException)
      } else {
        toast.error(this.$lang.Common.NoRecordInformed)
      }
    }
  }
}
</script>
<style scoped>
.block-upload {
  border: dashed 1px #ccc;
  border-radius: 5px;
  background-color: #f8f9fa;
  cursor: pointer;
}

.block-upload:hover {
  font-weight: bold;
  /*
  -webkit-transform: scale(1.2);
  -ms-transform: scale(1.2);
  transform: scale(1.2);
  transition: 1s ease;
  */
}

li {
  list-style-type: none;
}

li div {
  cursor: pointer;
  width: auto;
  display: initial;
}

.excel-color {
  color: #019727;
  padding-top: 10px;
}

.upload {
  height: 300%;
  width: 100%;
  opacity: 0.9;
  text-align: center;
  background: #efefef;
  display: block;
  position: absolute;
  z-index: 9;
  overflow: hidden;
  top: 0;
  left: 0;
}

.uploadText h2 {
  width: 100%;
  text-align: center;
  margin-top: 20%;
  display: block;
  position: absolute;
  z-index: 99999;
  top: 0;
  left: 0;
}

.uploadText h2 i {
  color: #04a791;
}

.upload-loading {
  display: block;
  position: absolute;
  z-index: 99999;
  top: 45%;
  left: 45%;
}

.upload-loading-img {
  margin: auto;
  display: block;
  opacity: 0.9;
}
</style>



// WEBPACK FOOTER //
// src/views/private/configurations/campaign/campaignlist/components/add/modal/uploadcontactmodal/uploadcontactmodal.vue